import { CARGO_ROW_TYPE_LABEL, TItemType } from '@types';
import { formatItemTypeDimensions } from './formatItemTypeDimensions';
import { formatNumber } from './formatNumber';

/** What counts as one unit of an Item type, in one line: "Bundle · max 180 × 40 × 40 cm · 10 kg". */
export const formatItemTypeDefinition = (
	itemType: Pick<TItemType, 'cargo_type' | 'max_length_cm' | 'max_width_cm' | 'max_height_cm' | 'max_weight_kg'>
) => {
	const cargoType = CARGO_ROW_TYPE_LABEL[itemType.cargo_type];
	return `${cargoType} · max ${formatItemTypeDimensions(itemType)} · ${formatNumber(itemType.max_weight_kg, { suffix: ' kg' })}`;
}
